import { gql } from "@apollo/client";

export const GQL_CUSTOMER_PUBLIC_AREA_INFO = gql`
   query customerPublicAreaInfo {
      customerPublicAreaInfo {
         customer {
            company_name
            fiscal_code
            tax_accounts {
               id
               code
               address
               place
               zip_code
               comune {
                  id
                  description
               }
               province {
                  id
                  description
               }
            }
         }
         waste_bin_types
         unit_measure_types
         form {
            tax_account_id
            items {
               id
               bin_type
               bin_capacity
               um
               cerCode {
                  id
                  code
                  description
               }
               frequency
               exposure_frequency
               bin_number
            }
         }
      }
   }
`;
